module.exports = __webpack_public_path__ + "static/media/Header_Gincu.26c09a77.jpg";